import type { GoogleMapType } from './session';

export const GOOGLE_BASEMAP_FLAG = 'google_basemap';

export type BasemapKey = 'standard' | 'aesthetic' | 'satellite' | 'transit';

export const LEGACY_BASEMAP_KEYS: readonly BasemapKey[] = ['standard', 'aesthetic', 'satellite', 'transit'];
export const GOOGLE_BASEMAP_KEYS: readonly BasemapKey[] = ['standard', 'satellite'];

const GOOGLE_MAP_TYPE_BY_BASEMAP: Record<BasemapKey, GoogleMapType> = {
  standard: 'roadmap',
  aesthetic: 'roadmap',
  satellite: 'satellite',
  transit: 'roadmap',
};

export function isGoogleBasemapActive(flagEnabled: boolean, apiKey: string | null): boolean {
  return flagEnabled && Boolean(apiKey);
}

export function availableBasemapKeys(googleActive: boolean): readonly BasemapKey[] {
  return googleActive ? GOOGLE_BASEMAP_KEYS : LEGACY_BASEMAP_KEYS;
}

export function googleMapTypeForBasemap(basemap: string): GoogleMapType {
  return GOOGLE_MAP_TYPE_BY_BASEMAP[basemap as BasemapKey] ?? 'roadmap';
}

export function basemapForGoogleMapType(mapType: GoogleMapType): BasemapKey {
  return mapType === 'satellite' ? 'satellite' : 'standard';
}

export function alternateGoogleMapType(mapType: GoogleMapType): GoogleMapType {
  return mapType === 'satellite' ? 'roadmap' : 'satellite';
}
